export default "__VITE_ASSET__qQcXMXCD__"